<template>
  <div>
    <v-tooltip
      :open-delay="1000"
      bottom
    >
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="mr-2 white"
          style="border-radius: 6px; border-width: 1px; border-style: solid; border-color: rgb(158 158 158 / 36%) !important; padding: 1px"
        >
          <v-checkbox v-show="mapHasLoaded"
            class="mt-0 mr-2"
            hide-details
            v-model="showStationsFromOtherActors"
            label="Vis tidsserier fra andre aktører"
          ></v-checkbox>          
        </div>
      </template>
      <span>{{showStationsFromOtherActors ? 'Skjul' : 'Vis'}} tidsserier fra MET, SVV, SMHI, Bane NOR og andre aktører.</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ExternalStationsToggle",  
  computed: {
    ...mapState(["mapHasLoaded"]),
    showStationsFromOtherActors: {
      set (showStationsFromOtherActors) {
        this.setShowStationsFromOtherActors(showStationsFromOtherActors);
      },
      get () {
        return this.$store.state.showStationsFromOtherActors;
      }
    }
  },
  methods: {
    ...mapActions(["setShowStationsFromOtherActors"])
  }
}
</script>

<style>
</style>